import { render, staticRenderFns } from "./HoverButton.vue?vue&type=template&id=3610c68e"
import script from "./HoverButton.vue?vue&type=script&lang=js"
export * from "./HoverButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3610c68e')) {
      api.createRecord('3610c68e', component.options)
    } else {
      api.reload('3610c68e', component.options)
    }
    module.hot.accept("./HoverButton.vue?vue&type=template&id=3610c68e", function () {
      api.rerender('3610c68e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/HoverButton.vue"
export default component.exports